import 'react-datepicker/dist/react-datepicker.css'

import { styled } from '@atom-web/core'
import Calendar from '@atom-web/icons-24/jsx/Calendar'
import ChevronRight from '@atom-web/icons-24/jsx/ChevronRight'
import Flight from '@atom-web/icons-24/jsx/Flight'
import People from '@atom-web/icons-24/jsx/People'
import { Popover } from '@atom-web/macros'
import {
	Box,
	Button,
	Column,
	Flex,
	Input,
	Row,
	Stack,
	Text,
} from '@atom-web/micros'
import moment from 'moment'
import { useRouter } from 'next/router'
import queryString from 'query-string'
import React, {
	forwardRef,
	Fragment,
	useCallback,
	useEffect,
	useState,
} from 'react'
import DatePicker from 'react-datepicker'

import getIndianCities from '../../../../components/gcm/utils/getIndianCities'
import { encodeHotelRoomConfig } from '../../../../utils/encodeHotelRoomConfig'
import DepatureCityComponent from './DepatureCity'
import DurationOfStay from './DurationOfStay'
import { useComponentDidUpdate } from './helper'
import TravelDetailRoom from './TravellerDetailsRoom'

function GcmComponent() {
	const router = useRouter()
	const { query } = router
	const TodayDate = new Date()
	const DatePickerWrapper = styled('div', {
		width: '100%',
		'.react-datepicker-popper': {
			marginTop: '$5',
			marginLeft: '-$8',
		},
		'.react-calander': {
			border: 0,
			borderBottom: 0,
		},
		'.react-datepicker__header': {
			borderBottom: 0,
			backgroundColor: '$white',
			padding: '$3',
		},
		'.react-datepicker__navigation': {
			top: '7px',
		},
		'.react-datepicker__day-names': {
			paddingTop: '$2',
		},
	})
	const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => {
		return (
			<Box
				className="example-custom-input"
				onClick={onClick}
				ref={ref}
				css={{
					backgroundColor: '$white',
					color: '#2c2f42',
					cursor: 'pointer',
					paddingLeft: '$4',
				}}
			>
				{value == '' ? 'Departure Date' : value}
			</Box>
		)
	})
	const [travelDetail] = useState([
		{ id: 1, type: 'Couple' },
		{ id: 2, type: 'Family' },
		{ id: 3, type: 'Friends' },
		{ id: 4, type: 'Solo' },
	])
	const [startDate] = useState(TodayDate.setDate(TodayDate.getDate() + 1))
	const [depatureDate, setdepatureDate] = useState('')
	const [open, setopen] = useState({
		shown: false,
		value: '',
	})
	const [travellerDetails, settravellerDetails] = useState([
		{
			room: 1,
			adultCount: 2,
			childAges: [],
			childrenVal: 0,
		},
	])
	const [cities, setcities] = useState([])
	const [selectedCity, setselectedCity] = useState('')
	const [durations, setDurations] = useState([])
	const [duration, setDuration] = useState(4)
	const [durationOfStayopen, setdurationOfStayOpen] = useState(false)
	const [childvalueshown, setchildvalueshown] = useState(false)
	const [retainState, setretainState] = useState(false)
	useEffect(() => {
		getIndianCities(res => {
			setcities(res)
		})
	}, [])
	useEffect(() => {
		const arr = new Array(4).fill(null).map((_, index) => ({
			val: index === 0 ? 'night' : 'nights',
		}))
		setDurations(arr)
	}, [])

	const increement = useCallback(() => {
		const val = [...durations]
		val.push({ val: 'nights' })
		setDurations(val)
		setDuration(val.length)
	}, [durations])

	const decreement = useCallback(() => {
		const val = [...durations]
		val.pop()
		setDurations(val)
		setDuration(val.length)
	}, [durations])

	const dropDownCloseFunction = useCallback(event => {
		setDuration(event)
		setdurationOfStayOpen(false)
	}, [])
	const dropDownOnchange = useCallback(event => {
		setdurationOfStayOpen(event)
	}, [])
	const showGetCostModal = useCallback(() => {
		if (query.m !== 'mle-landing') {
			const query = {
				m: 'mle-landing',
			}
			router.push(
				{
					pathname: router.asPath.split('?')[0],
					query,
				},
				null,
				{ shallow: true, scroll: false },
			)
		}
	}, [router])
	const [childCountt, setchildCountt] = useState(0)
	const donefunction = event => {
		settravellerDetails([])
		let childCount = 0
		if (event.roomDetails) {
			setchildvalueshown(true)
			settravellerDetails(event.roomDetails)
			event.roomDetails.forEach(element => {
				childCount += element.childrenVal
				return setchildCountt(childCount)
			})
			setopen({
				shown: false,
				value: '',
			})
		}
	}
	const onCloseModal = () => {
		setopen({ shown: false })
	}
	const onselectCity = useCallback(event => {
		setselectedCity(event)
	}, [])

	const routingFunction = () => {
		if (selectedCity != '' && depatureDate != '') {
			const obj = {
				date: moment(depatureDate).format('YYYY-MM-DD'),
				from:
					selectedCity.label == 'Outside India' ||
					selectedCity.label == 'Already Booked'
						? '$$$'
						: selectedCity.value,
				travellers: encodeHotelRoomConfig(travellerDetails) || 'a2',
				duration,
				nationality: 'IN',
				arrivalAirportCode:
					selectedCity.label == 'Outside India' ||
					selectedCity.label == 'Already Booked'
						? '$$$'
						: selectedCity.value,
				arrivalAirportName:
					selectedCity.label == 'Outside India' ||
					selectedCity.label == 'Already Booked'
						? '$$$'
						: selectedCity.label?.split(',')[0],
			}
			router.push(
				`/maldives-tour-packages/listing?${queryString.stringify(obj)}`,
				null,
				{ shallow: true },
			)
		}
	}
	useComponentDidUpdate(() => {
		setretainState(true)
	}, [travellerDetails])
	return (
		<Stack
			css={{
				flexDirection: 'row',
				width: 'auto',
				position: 'absolute',
				bottom: '-8%',
				zIndex: 2,
				marginLeft: '16px',
				marginRight: '16px',
				'@lg': {
					flexDirection: 'row',
					width: '100%',
					bottom: '30%',
					display: 'flex',
					alignItems: 'center',
				},
				'@smMax': {
					marginBottom: '$6',
					marginLeft: '$2',
					marginRight: '$2',
				},
			}}
		>
			<Box
				css={{
					boxShadow: 'rgb(0 0 0 / 10%) 0px 3px 20px',
					flexWrap: 'wrap',
					flexDirection: 'row',
					backgroundColor: 'White',
					borderRadius: '$2',
					display: 'flex',
					justifyContent: 'center',
					'@lg': {
						flexDirection: 'row',
						flexWrap: 'nowrap',
						width: '60%',
						marginLeft: '10%',
						paddingTop: '$1',
						paddingBottom: '$1',
					},
					'@smMax': {
						paddingBottom: '6px',
					},
				}}
			>
				<Flex
					align={'center'}
					css={{
						width: 'auto',
						paddingTop: '2',
						paddingBottom: '$2',
						flexWrap: 'wrap',
						justifyContent: 'center',
						'@lg': {
							flexWrap: 'nowrap',
							flexDirection: 'row',
							width: '100%',
							padding: 0,
							height: '50px',
						},
					}}
				>
					<Row
						align="center"
						css={{
							width: '49%',
							borderRight: 1,
							borderRightStyle: 'solid',
							borderRightColor: 'rgba(0, 0, 0, 0.1)',
							height: '56px',
							'@lg': {
								padding: '$2 $2 $2 $4',
								display: 'flex',
								width: '100%',
							},
							'@smMax': {
								borderBottom: 1,
								borderBottomStyle: 'solid',
								borderBottomColor: 'rgba(0, 0, 0, 0.1)',
							},
						}}
					>
						<Row
							align="center"
							css={{
								'@smMax': {
									display: 'none',
								},
							}}
						>
							<Flight />
							<DepatureCityComponent
								cities={cities}
								onpress={onselectCity}
								selectedCity={selectedCity}
							/>
						</Row>
						<Row
							css={{
								paddingLeft: '$2',
								'@lg': {
									display: 'none',
								},
							}}
							gap="2"
							onClick={showGetCostModal}
						>
							<Flight />
							<Text
								css={{
									color: '#757575',
								}}
							>
								Departure City
							</Text>
						</Row>
					</Row>
					<Row
						align="center"
						css={{
							width: '49%',
							padding: '$2',
							height: '56px',
							'@lg': {
								display: 'flex',
								width: '100%',
								justifyContent: 'center',
								borderRight: 1,
								borderRightStyle: 'solid',
								borderRightColor: 'rgba(0, 0, 0, 0.1)',
							},
							'@smMax': {
								borderBottom: 1,
								borderBottomStyle: 'solid',
								borderBottomColor: 'rgba(0, 0, 0, 0.1)',
							},
						}}
					>
						<Column
							css={{
								width: '90%',
								'@smMax': {
									display: 'none',
								},
							}}
						>
							<Row align="center">
								<Calendar />
								<DatePickerWrapper>
									<DatePicker
										selected={depatureDate}
										onChange={date => setdepatureDate(date)}
										customInput={<ExampleCustomInput />}
										minDate={startDate}
										popperClassName={'react-datepicker-popper'}
										calendarClassName={'react-calander'}
										dateFormat="YYY-MM-dd"
									/>
								</DatePickerWrapper>
							</Row>
						</Column>
						<Row
							css={{
								'@lg': {
									display: 'none',
								},
							}}
							gap="2"
							onClick={showGetCostModal}
						>
							<Calendar />
							<Text
								css={{
									color: '#757575',
								}}
							>
								Departure Date
							</Text>
						</Row>
					</Row>
					<Row
						align="center"
						css={{
							width: '49%',
							borderRight: 1,
							borderRightStyle: 'solid',
							borderRightColor: 'rgba(0, 0, 0, 0.1)',
							padding: '$2',
							height: '56px',
							'@lg': {
								display: 'flex',
								width: '100%',
								justifyContent: 'center',
							},
						}}
					>
						<Row
							align="center"
							gap="1"
							css={{
								'@smMax': {
									display: 'none',
								},
							}}
						>
							<DurationOfStay
								durations={durations}
								duration={duration}
								onclick={dropDownCloseFunction}
								increement={increement}
								decreement={decreement}
								open={durationOfStayopen}
								dropDownOnchange={dropDownOnchange}
							/>
						</Row>
						<Row
							css={{
								'@lg': {
									display: 'none',
								},
							}}
							align="center"
							gap="2"
							onClick={showGetCostModal}
						>
							<Calendar />
							<Column gap="1">
								<Text
									css={{
										color: '#757575',
										fontSize: '12px',
									}}
								>
									Duration of stay
								</Text>
								<Text
									css={{
										color: 'rgba(0,0,0,0.8)',
									}}
								>
									4 nights
								</Text>
							</Column>
						</Row>
					</Row>
					<Row
						align="center"
						css={{
							width: '49%',
							padding: '$2',
							height: '56px',
							'@lg': {
								display: 'flex',
								width: '100%',
								paddingLeft: '$4',
							},
						}}
					>
						<Row
							align="center"
							css={{
								'@smMax': {
									display: 'none',
								},
								width: '120%',
							}}
						>
							<People />
							<Column css={{ width: '100%', overflow: 'unset' }}>
								<Popover.Root
									open={open.shown}
									onOpenChange={value => {
										setopen({
											shown: value,
											value: open.value,
										})
									}}
								>
									<Popover.Trigger asChild>
										<Input
											type={'text'}
											placeholder="Traveller details"
											css={{
												boxShadow: 'none',
												'&:focus': {
													boxShadow: 'none',
												},
												'&::placeholder': {
													color: '#2c2f42',
													fontSize: '16px',
													fontFamily: 'Source Sans Pro',
													paddingLeft: '$1',
												},
												color: '#2c2f42',
												fontSize: '16px',
												fontFamily: 'Source Sans Pro',
												paddingLeft: '$1',
											}}
											value={
												open.value === 'Solo'
													? '1 Adult, 1 room'
													: open.value === 'Couple'
													? '2 Adult, 1 room'
													: `${travellerDetails.reduce((acc, curr) => {
															return acc + curr.adultCount
													  }, 0)} ${childCountt > 0 ? 'A +' : 'Adult ,'}${
															childCountt > 0 && childvalueshown
																? ' ' + +childCountt + 'C,'
																: ''
													  }${' ' + travellerDetails.length} ${
															travellerDetails.length > 1 ? 'rooms' : 'room'
													  }`
											}
										/>
									</Popover.Trigger>
									<Popover.Content
										css={{
											backgroundColor: '$white',
											marginTop: '30px',
											height: '250px',
											width: '250px',
											padding: 0,
											opacity: 2,
										}}
									>
										{travelDetail.map((item, index) => {
											return (
												<Fragment key={'travel-details-' + index}>
													{index === 1 || index === 2 ? (
														<Row
															key={'travel-details-' + index}
															justify={'between'}
															align={'center'}
															css={{
																height: '25%',
																boxShadow: 'rgb(229 229 229) 0px 1px 0px 0px',
																'&:hover': {
																	backgroundColor: '$white',
																	boxShadow: 'rgb(0 0 0 / 20%) 0px 3px 15px',
																	borderTopLeftRadius: index == 0 ? '$3' : 0,
																	borderTopRightRadius: index == 0 ? '$3' : 0,
																},
																padding: '0 $4',
																cursor: 'pointer',
															}}
														>
															<Popover.Root>
																<Popover.Trigger asChild>
																	<Row
																		css={{
																			width: '100%',
																			height: '100%',
																			alignItems: 'center',
																		}}
																	>
																		<Text
																			css={{
																				fontSize: '$4',
																				color: '$black',
																				lineHeight: '21px',
																				fontWeight: '$normal',
																				userSelect: 'none',
																			}}
																		>
																			{item.type}
																		</Text>
																	</Row>
																</Popover.Trigger>
																<Popover.Content
																	css={{
																		backgroundColor: '$white',
																		height: '360px',
																		padding: 0,
																		margin: 0,
																		position: 'absolute',
																		left: '130px',
																		width: '280px',
																	}}
																>
																	<TravelDetailRoom
																		selectetype={item.type}
																		onchangee={donefunction}
																		onCloseModal={onCloseModal}
																		Details={
																			retainState ? travellerDetails : ''
																		}
																	/>
																</Popover.Content>
																<ChevronRight
																	fill="rgba(0, 0, 0, 0.5)"
																	fontSize={'12px'}
																/>
															</Popover.Root>
														</Row>
													) : (
														<Column
															onClick={() => {
																setopen({ shown: false, value: item.type })
																if (item.type === 'Couple') {
																	settravellerDetails([
																		{
																			room: 1,
																			adultCount: 2,
																			childAges: [],
																			childrenVal: 0,
																		},
																	])
																} else if (item.type === 'Solo') {
																	settravellerDetails([
																		{
																			room: 1,
																			adultCount: 1,
																			childAges: [],
																			childrenVal: 0,
																		},
																	])
																}
															}}
															justify={'center'}
															css={{
																height: '25%',
																boxShadow: 'rgb(229 229 229) 0px 1px 0px 0px',
																'&:hover': {
																	backgroundColor: '$white',
																	boxShadow: 'rgb(0 0 0 / 20%) 0px 3px 15px',
																	borderTopLeftRadius: index == 0 ? '$3' : 0,
																	borderTopRightRadius: index == 0 ? '$3' : 0,
																},
																cursor: 'pointer',
															}}
														>
															<Text
																css={{
																	fontSize: '$4',
																	color: '$black',
																	lineHeight: '21px',
																	fontWeight: '$normal',
																	marginLeft: '$4',
																	userSelect: 'none',
																}}
															>
																{item.type}
															</Text>
														</Column>
													)}
												</Fragment>
											)
										})}
									</Popover.Content>
								</Popover.Root>
							</Column>
						</Row>
						<Row
							css={{
								'@lg': {
									display: 'none',
								},
							}}
							align="center"
							gap="2"
							onClick={showGetCostModal}
						>
							<People />
							<Column gap="1">
								<Text
									css={{
										color: '#757575',
										fontSize: '12px',
										userSelect: 'none',
									}}
								>
									Traveller details
								</Text>
								<Text
									css={{
										color: 'rgba(0,0,0,0.8)',
										userSelect: 'none',
									}}
								>
									2 adults, 1 room
								</Text>
							</Column>
						</Row>
					</Row>
					<Button
						onClick={showGetCostModal}
						css={{
							width: '90%',
							textAlign: 'center',
							fontSize: '$3',
							color: '$white',
							fontWeight: '$extrabold',
							backgroundColor: '$primary05',
							height: '50px',
							borderRadius: '$2',
							borderColor: '$primary05',
							'@lg': {
								display: 'none',
							},
						}}
					>
						Search for Packages
					</Button>
				</Flex>
			</Box>
			<Button
				onClick={() => routingFunction()}
				css={{
					display: 'none',
					'@lg': {
						display: 'flex',
						width: '20%',
						textAlign: 'center',
						fontSize: '$3',
						color: '$white',
						fontWeight: '$extrabold',
						backgroundColor: '$primary05',
						height: '50px',
						borderRadius: '$2',
						borderColor: '$primary05',
						userSelect: 'none',
						boxShadow: 'none',
						pointerEvents:
							selectedCity != '' && depatureDate != '' ? null : 'none',
						opacity: selectedCity != '' && depatureDate != '' ? 1 : 0.65,
					},
				}}
			>
				Search for Packages
			</Button>
		</Stack>
	)
}
export default GcmComponent
